<div class="w-full bg-white grid grid-cols-3 gap-2 px-3 py-6">
  <div class="text-secondary-500 text-center flex flex-col gap-2 lg:text-6xl md:text-4xl sm:text-2xl text-xl">
    <div class="font-bold"> {{ serviceCount }}</div>
    <div class="text-primary-500 lg:text-[16px] md:text-[14px] text-[11px]">{{ "Idadi ya huduma"|concat|translate }}
    </div>
  </div>
  <div
    class="text-secondary-500 text-center  lg:text-6xl md:text-4xl sm:text-2xl text-xl flex items-center justify-between">
    <span class="h-1/3 w-1 rounded-lg bg-primary-500"></span>
    <span class="flex flex-col gap-2">
      <div class="font-bold"> {{ idadiYaTaasisi }}</div>
      <div
        class="text-primary-500 lg:text-[16px] md:text-[14px] text-[11px]">{{ "Idadi ya taasisi"|concat|translate }}</div>
    </span>
    <span class="h-1/3 w-1 rounded-lg bg-primary-500"></span>
  </div>
  <div class="text-secondary-500 text-center flex flex-col gap-2 lg:text-6xl md:text-4xl sm:text-2xl text-xl">
    <div class="font-bold"> {{ hudumaZilizoOmbwa }}</div>
    <div
      class="text-primary-500 lg:text-[16px] md:text-[14px] text-[11px]">{{ "Huduma zilizoombwa"|concat|translate }}
    </div>
  </div>
</div>
